<template>
  <v-app v-if="this.auth == 1" id="inspire">
    <ChangePwd />

    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
    >
      <v-list id="side_menu" dense>
        <template v-for="item in MENU_OPTIONS">
          <v-list-item
            v-if="
              $_HASPERMISSION(item.name, getSession.user.id_tipo_utilizador)
            "
            :key="item.text"
            :to="item.to"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <div v-if="$vuetify.breakpoint.lgAndUp" class="logo-bar">
          <img :src="require('@/assets/logo.png')" />
          <div class="animation-shap">
            <div class="shap-bg"></div>
          </div>
        </div>
      </v-list>
    </v-navigation-drawer>

    <RightMenu />

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      :color="$primary"
      dark
      app
      fixed
    >
      <v-toolbar-title style="width: 600px" class="ml-0 pl-3">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Hema</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text v-on:click="personalData"
        >Bem-vindo, {{ getSession.user.nome }}</v-btn
      >
      <span class="divi">|</span>
      <v-btn v-on:click.stop="personalData" icon>
        <v-icon>mdi-lock-open</v-icon>
      </v-btn>
      <v-btn v-on:click.stop="logout" icon>
        <v-icon>power_settings_new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content id="main_content">
      <v-container fluid fill-height>
        <v-row>
          <PickerInstituicao
            id="PickerInstituicao"
            v-if="
              $_HASPERMISSION(
                'PickerInstituicao',
                getSession.user.id_tipo_utilizador
              )
            "
          />
          <router-view></router-view>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
  <Login v-else-if="this.auth == 0" />
</template>

<script>
import { instance as axios } from "@/store/_AXIOS"
import { _TOKENLOGIN, _DECODELOGIN } from "@/store/_JWT"
import _MENU from "@/store/_MENU"

import "./style.scss"

export default {
  components: {
    PickerInstituicao: () => import("@/components/PickerInstituicao"),
    RightMenu: () => import("@/components/dialogs/RightMenu"),
    ChangePwd: () => import("@/components/dialogs/ChangePwd")
  },
  data: () => ({
    auth: -1,
    drawer: null,
    email: "",
    pwd: "",
    cpwd: "",
    altpwd: false,
    defaultRules: null,
    pwdRules: null
  }),
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    },
    MENU_OPTIONS() {
      return _MENU
    }
  },
  watch: {},
  created() {
    //this.OpenStore();
    this.ManageSession()

    this.$eventBus.$on("login", res => {
      if (res) this.SessionStart()
      else this.logout()
    })
    this.$eventBus.$on("logout", err => {
      this.logout()
    })

    this.$eventBus.$on("ChangePickerInstituicao", () => {
      this.$cookies.set("i", this.getSession.instituicao)
      this.OpenStore()
    })

    this.defaultRules = [v => !!v || this.$requiredField + ""]
    this.pwdRules = [v => v == this.pwd || "*As passwords não coincidem."]
  },
  methods: {
    personalData() {
      this.$eventBus.$emit("ChangePwdDialog", true)
    },

    ManageSession() {
      if (!this.$session.exists()) this.auth = 0
      else {
        axios.defaults.headers.common["Authorization"] = this.$cookies.get(
          "auth"
        )
        _DECODELOGIN(this.$cookies.get("t")).then(res => {
          this.$store
            .dispatch("session/getData", {
              email: res
            })
            .then(() => {
              if (this.getSession.session) {
                this.SessionStart()
              } else this.auth = 0
            })
        })
      }
    },

    SessionStart() {
      this.$session.start()
      this.$cookies.config("3d")
      this.$cookies.set("t", _TOKENLOGIN(this.getSession.user.email))
      this.$cookies.set("auth", this.getSession.user.auth)
      axios.defaults.headers.common["Authorization"] = this.getSession.user.auth
      this.BaseStore()
      this.OpenStore()
    },

    getInstituicao() {
      return new Promise((resolve, reject) => {
        resolve(
          this.$cookies.get("i")
            ? this.$cookies.get("i")
            : this.getSession.user.info.instituicoes[0].id_instituicao
        )
      })
    },

    OpenStore() {
      this.getInstituicao().then(instituicao => {
        this.getSession.instituicao = instituicao

        this.$store.dispatch("utilizador/getByInstituicao", instituicao)
        this.$store.dispatch("brigada/getByInstituicao", instituicao)
        this.$store.dispatch("colheita/getByInstituicao", instituicao)
        this.$store.dispatch("galardao_pedido/getByInstituicao", instituicao)
        this.$store.dispatch("associado/getByInstituicao", instituicao)
        this.$store.dispatch("notificacao/getByInstituicao", instituicao)
        this.$store.dispatch("donativo/getByInstituicao", instituicao)
        if (this.$_ISUSER(this.getSession.user.id_tipo_utilizador))
          this.$store.dispatch("stats/getByInstituicao", instituicao)
        this.auth = 1
      })
    },

    async BaseStore() {
      this.$store.dispatch("termos/get")
      this.$store.dispatch("dadiva/get")
      this.$store.dispatch("tipo_utilizador/get")
      this.$store.dispatch("localidade/getAllDistritos")
      this.$store.dispatch("nacionalidade/get")
      this.$store.dispatch("genero/get")
      this.$store.dispatch("gs/get")
      this.$store.dispatch("estado_civil/get")
      this.$store.dispatch("galardao/get")
    },

    logout() {
      this.$store.dispatch("session/setSessionData", null).then(() => {
        this.auth = 0
        this.$session.destroy()
        delete axios.defaults.headers.common["Authorization"]
      })
    }
  }
}
</script>
